import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getTaskAdminBasePath, getTaskAdminBaseRoute, } from "../AdminTaskRoutes";
import ActionPlanCreate from "../../../../../../components/taskAdmin/actionPlans/actionPlanCreate";
import ActionPlanEdit from "../../../../../../components/taskAdmin/actionPlans/actionPlanEdit";
import ActionPlanDetail from "../../../../../../components/taskAdmin/actionPlans/actionPlanDetail";
import ActionPlanIndex from "../../../../../../components/taskAdmin/actionPlans/actionPlanIndex";
// Routes
export const getTaskAdminActionPlanBaseRoute = () => `${getTaskAdminBaseRoute()}/actionplan`;
export const getTaskAdminActionPlanCreateRoute = () => `${getTaskAdminActionPlanBaseRoute()}/create`;
export const getTaskAdminActionPlanEditRoute = () => `${getTaskAdminActionPlanBaseRoute()}/edit/:planId`;
export const getTaskAdminActionPlanDetailRoute = () => `${getTaskAdminActionPlanBaseRoute()}/:planId`;
// Paths
export const getTaskAdminActionPlanBasePath = () => `${getTaskAdminBasePath()}/actionplan`;
export const getTaskAdminActionPlanCreatePath = () => `${getTaskAdminActionPlanBasePath()}/create`;
export const getTaskAdminActionPlanEditPath = (planId) => `${getTaskAdminActionPlanBasePath()}/edit/${planId}`;
export const getTaskAdminActionPlanDetailPath = (planId) => `${getTaskAdminActionPlanBasePath()}/${planId}`;
const AdminActionPlansRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: ActionPlanCreate, path: getTaskAdminActionPlanCreateRoute() }), _jsx(Route, { component: ActionPlanEdit, path: getTaskAdminActionPlanEditRoute() }), _jsx(Route, { component: ActionPlanDetail, path: getTaskAdminActionPlanDetailRoute() }), _jsx(Route, { component: ActionPlanIndex, path: getTaskAdminActionPlanBaseRoute() })] }));
};
export default AdminActionPlansRoutes;
